export interface Comment {
  id: string;
  userId: string;
  userName: string;
  date: Date;
  comment: string;
}
